export default "__VITE_ASSET__e22fb890__"